(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["november-newsletter"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const key = 'osiris-lab20-november-2026-dismissed';
    const end = Date.parse('2026-12-01T00:00:00-05:00');
    function initialize(root) {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';
      const dialog = root.querySelector('dialog');
      const trigger = root.querySelector('.od-promo__bar');
      let timer;
      function open() {
        if (Date.now() >= end) { root.hidden = true; return; }
        if (!dialog.open) dialog.showModal();
      }
      function dismiss() {
        dialog.close();
        clearTimeout(timer);
        try { localStorage.setItem(key, String(Date.now())); } catch {}
      }
      trigger.addEventListener('click', open);
      root.querySelector('.od-promo__close').addEventListener('click', dismiss);
      dialog.addEventListener('cancel', event => { event.preventDefault(); dismiss(); });
      dialog.addEventListener('click', event => {
        const box = dialog.getBoundingClientRect();
        if (event.target === dialog && (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom)) dismiss();
      });
      let dismissed = 0;
      try { dismissed = Number(localStorage.getItem(key)) || 0; } catch {}
      const success = dialog.querySelector('[data-success]');
      const errors = dialog.querySelector('[role=alert]');
      if (success || errors) open();
      else if (root.dataset.preview === 'true' || (root.dataset.auto === 'true' && Date.now() - dismissed > 604800000)) timer = setTimeout(open, Number(root.dataset.delay) * 1000);
      if (Date.now() >= end) root.hidden = true;
    }
    const initializeAll = () => document.querySelectorAll('.od-promo').forEach(initialize);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeAll);
    else initializeAll();
    document.addEventListener('shopify:section:load', initializeAll);
  })();

  } catch(e) { console.error(e); }
})();
})();
